import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'employeeTooltipResumeDate'
})
export class EmployeeTooltipResumeDatePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(value: string): unknown {

    if (value === null)
    {
      return '';
    }
    return  `<div class='text-left'>
    <span class='text-left mgn-bottom-5 d-inline-block'>
    Fecha de recepción de CV: ${this.datePipe.transform(value, 'dd/MM/yyyy')}
    </span></div>`;

  }
}
